import { Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { depositValidation } from "../../utils/validation/depositValidation";

export default function Deposit() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const formHandler = async (values, { resetForm }) => {
    if (user?._id) {
      const body = {
        ...values,
        user: user._id,
        isCommission: values.isCommission == "true" ? true : false,
        amount: Number(values.amount),
      };

      try {
        const response = await postApi({
          path: "admin/wallets/deposit",
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("تراکنش با موفقیت انجام شد");
        resetForm();
        navigate("/wallets-transaction");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("لطفا یک کاربر انتخاب کنید.");
    }
  };

  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);

  const userModalRef = useRef();
  const amountRef = useRef();

  const handleUser = (data) => {
    setUser(data);
    setUserName(data?.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
  };

  return (
    <AdminFormLayout title={"افزودن تراکنش"} description="کاربر، مبلغ و توضیحات تراکنش کیف پول را مشخص کنید.">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <Formik
        enableReinitialize
        initialValues={{
          amount: "",
          isCommission: "true",
          description: "",
        }}
        validationSchema={depositValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div>
                  <span id="wallet-user-label" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب کاربر
                  </span>
                  <button
                    type="button"
                    aria-labelledby="wallet-user-label wallet-user-selection"
                    onClick={() => userModalRef?.current?.showModal()}
                    className="flex w-full flex-wrap items-center justify-between gap-2 rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-right text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                  >
                    <span id="wallet-user-selection">{userName || "برای انتخاب کاربر کلیک کنید"}</span>
                    <span className="text-blue-700 dark:text-blue-300">{user ? "تغییر کاربر" : "انتخاب"}</span>
                  </button>
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    مبلغ
                  </label>
                  <CurrencyInput
                    placeholder="مبلغ"
                    ref={amountRef}
                    name="amount"
                    inputValue={formik.values["amount"]}
                    onChange={(e) => formik.setFieldValue("amount", e)}
                  />
                  {formik.errors.amount && formik.touched.amount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.amount}
                    </p>
                  ) : null}
                </div>

                <Select
                  name="isCommission"
                  placeholder="نوع تراکنش"
                  label="تراکنش کمیسیون است؟"
                >
                  <option value={"true"}>بله</option>
                  <option value={"false"}>خیر</option>
                </Select>
                <Input
                  name={"description"}
                  placeholder={"توضیحات"}
                  label={"توضیحات"}
                  type="text"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <div className="admin-form-actions">
                  <Button disabled={formik.isSubmitting} loading={formik.isSubmitting} type="submit"
                    text={location?.state ? "ویرایش" : "افزودن"}
                    color={"success"}
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/wallets-transaction")}>انصراف</button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </AdminFormLayout>
  );
}
